$(function () {
    $("#printButton").on("click", function () {
        var printParamByCheckboxId = {
            printImage: "image",
            printQRCode: "qrCode",
            printObituary: "obituary",
            printMemorialBook: "memorialBook",
            printPhotoAlbum: "photoAlbum",
            printTributes: "tributes"
        };
        var queryParts = ["id=" + encodeURIComponent(puritanLawn.viewModel.deceasedId)];

        $("#printImage, #printQRCode, #printObituary, #printMemorialBook, #printPhotoAlbum, #printTributes")
            .filter(":checked")
            .each(function () {
                var param = printParamByCheckboxId[this.id];
                if (param) {
                    queryParts.push(param + "=true");
                }
            });

        var url = puritanLawn.deceasedServicesBaseAddress + "Print?" + queryParts.join("&");

        window.open(url, "_blank");
    });

    $("#bookmarkToggleButton").click(function (e) {
        var userId = puritanLawn.user.id;
        var deceasedId = puritanLawn.viewModel.deceasedId;

        puritanLawn.ajaxGet(puritanLawn.deceasedServicesBaseAddress + 'ToggleBookmark?userId=' + userId + '&deceasedId=' + deceasedId,
            function (results) {
                var classToRemove = ((results.isBookmarked) ? "far" : "fas");
                var classToAdd = ((results.isBookmarked) ? "fas" : "far");

                $("#bookmarkToggleButton").removeClass(classToRemove).addClass(classToAdd);
            },
            function (response) {
                alert("error");
            }
        );
    });

    $(".updateRemembranceButton").click(function (e) {
        if (puritanLawn.viewModel.userIsRegistered === false) {
            e.preventDefault();

            puritanLawn.showTwoButtonModal("Update Remembrance",
                "You need to be registered and logged in to update a remembrance...",
                "Login",
                function () {
                    window.location = '/Identity/Account/Login?returnUrl=@Context.Request.GetEncodedPathAndQuery()';
                },
                "Register",
                function () {
                    window.location = '/Identity/Account/Register?returnUrl=@Context.Request.GetEncodedPathAndQuery()';
                }
            );
        }
    });

    $("#gpsButton").click(function (e) {
        window.open(puritanLawn.viewModel.gpsUrl, "_blank");
    });

    $(".memorialContentDeleteForm").on("submit", function (e) {
        e.preventDefault();

        var form = $(this);
        var itemType = form.data("pl-itemtype") || "entry";

        puritanLawn.showTwoButtonModal(
            "Delete",
            "Are you sure you want to delete this " + itemType + "?",
            "Cancel",
            null,
            "Delete",
            function () {
                form.off("submit");
                form.submit();
            }
        );
    });

    $(".disinterForm").on("submit", function (e) {
        e.preventDefault();

        var form = $(this);

        puritanLawn.showTwoButtonModal(
            "Disinter",
            "Are you sure you want to mark this record as disinterred?",
            "Cancel",
            null,
            "Disinter",
            function () {
                form.off("submit");
                form.submit();
            }
        );
    });
});

function initViewModel(model) {
    var viewModel = {
        deceasedId: model.deceasedId,
        deceasedImagePathRoot: model.deceasedImagePathRoot,
        userIsRegistered: model.userIsRegistered,
        gpsUrl: model.gpsUrl
    }

    return viewModel;
}